import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { serchSelect, tabulation, gmToolNewPage, gmTool, customPaging } from "@/mixins/index";
import { bagRetainDesc } from "@/api/dataAll/dataAll";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
import { template } from 'lodash';
export default {
  name: "latestInventory",
  mixins: [serchSelect, tabulation, gmToolNewPage, gmTool, customPaging],
  data: function data() {
    return {
      more: true,
      value2: [],
      paramsData: {
        starttime: ''
      },
      // PrimitiveserverLists: [],
      // serverLists: [],
      tableData: [],
      // Dynamic: [],
      // isServer: false,
      serverList: []
    };
  },
  created: function created() {
    this.getsearchDate();
    this.searchData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';

    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  methods: {
    getsearchDate: function getsearchDate() {
      var now = new Date(this.$times.zeroTimeZone());
      var year = now.getFullYear();
      var month = (now.getMonth() + 1).toString().length < 2 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
      var date = now.getDate().toString().length < 2 ? "0" + now.getDate() : now.getDate();
      var date = year + "-" + month + "-" + date;
      this.paramsData.starttime = date;
    },
    getServer: function getServer() {
      var _this = this;

      this.paramsData.server_id = '';
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this.serverList = res.data;
        }
      });
    },
    searchClick: function searchClick() {
      var _this2 = this;

      this.paramsData.endtime = this.paramsData.starttime;
      var data = JSON.parse(JSON.stringify(this.paramsData));

      if (this.rawData.game_mark.indexOf('royalpirates') > -1 && !data.is_prod) {
        this.$message.error(this.$t('selectEnvironment'));
        return;
      }

      if (data.server_id.length == 0) {
        this.$message.error(this.$t('pleaseSelectServer'));
        return;
      }

      this.reqLoading = true;
      var reqFn = bagRetainDesc;
      reqFn(_objectSpread(_objectSpread({}, this.searchData), data)).then(function (res) {
        if (res.status == 200) {
          _this2.currentPage = 1;
          var tableNewdata = res.data.data;
          var list = _this2.rawData.game_mark.indexOf('royalpirates') > -1 ? _this2.serverList : _this2.serverListYJ;
          tableNewdata.forEach(function (item) {
            var foundData = list.find(function (b) {
              return b.serverID == item.server_id;
            });
            item.server_name = foundData ? foundData.serverName : '/';
          });
          _this2.tableCopyTableList = JSON.parse(JSON.stringify(tableNewdata));
          _this2.tableData = _this2.currentChangePage(_this2.pageSize, _this2.currentPage);

          _this2.$nextTick(function () {
            _this2.getTableRight();
          });
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('date'),
        prop: 'date'
      }, {
        label: this.$t('game'),
        prop: 'game'
      }, {
        label: this.$t('platform'),
        prop: 'platform'
      }, {
        label: this.$t('channel'),
        prop: 'channel'
      }, {
        label: this.$t('pkg'),
        prop: 'pkg'
      }, {
        label: this.$t('roleId'),
        prop: 'role_id'
      }, {
        label: this.$t('serverName'),
        prop: 'server_name'
      }, {
        label: this.$t('itemNameLabel'),
        prop: 'item_name'
      }, {
        label: this.$t('itemIdField'),
        prop: 'item_id'
      }, {
        label: this.$t('quantity'),
        prop: 'total_num'
      }];
      this.$export.excel({
        columns: columns,
        data: this.tableCopyTableList,
        title: this.$route.meta.title
      });
    }
  }
};